import { useMemo } from 'react';
import Cookies from 'js-cookie';
import {
  ProductStockStatus,
  RECENTLY_VIEWED_PRODUCTS_KEY,
  useProductService,
  useRegionCurrency,
} from '@skin-seoul/service';

export const useRecentlyViewedProductIds = () => {
  const { useGetProductsByIds } = useProductService();
  const { currency } = useRegionCurrency();
  const recentlyViewedIds = useMemo(() => {
    const rawRecentlyViewed = Cookies.get(RECENTLY_VIEWED_PRODUCTS_KEY);

    if (!rawRecentlyViewed) {
      return [];
    }

    const ids = rawRecentlyViewed.split('|').filter(Boolean).map(Number);

    if (ids.length === 0) {
      Cookies.remove(RECENTLY_VIEWED_PRODUCTS_KEY);
      return [];
    }

    return ids;
  }, []);

  const { data: recentlyViewedData } = useGetProductsByIds({
    ids: recentlyViewedIds.join(','),
    currency,
  });

  const filteredRecentlyViewedProducts = recentlyViewedData?.filter(
    (product) => product.status === ProductStockStatus.instock,
  );

  return {
    recentlyViewedIds,
    hasProducts: filteredRecentlyViewedProducts && filteredRecentlyViewedProducts.length > 0,
    inStockRecentlyViewedProductIds:
      (filteredRecentlyViewedProducts && filteredRecentlyViewedProducts.map((product) => product.productId)) || [],
    hasInStockProducts: filteredRecentlyViewedProducts && filteredRecentlyViewedProducts.length > 0,
  };
};
